import { render } from "./Horizontal.vue?vue&type=template&id=1611bcd0"
import script from "./Horizontal.vue?vue&type=script&lang=ts"
export * from "./Horizontal.vue?vue&type=script&lang=ts"
script.render = render

export default script